fx.translations("es", {
   
    "Sauvegarde de votre mise en page ..." : "Guardando el diseño...",

    "Les photos HEIC doivent être totalement téléchargées pour être utilisées pour la création automatique." : "Las imágenes HEIC no pueden utilizarse para la creación automática.",

    "Aller à votre album" : "Ir a su álbum",
    "Choisissez votre album en fonction de votre budget" : "Elija su álbum según su presupuesto",
    "Cliquez pour voir les détails" : "Haga clic para ver los detalles",
    "Pour ajouter une Photo" : "Para añadir una foto",
    "Déplacez une photo depuis la galerie" : "Arrastre una foto desde la galería",
    "Sélectionnez au minimum une trentaine de photos" : "Seleccione al menos unas treinta fotos"
});

